// Modules
import React from "react";

// Components
import ResortDropdownSelectedItem from './ResortDropdownSelectedItem';

type Props = {
    selected: string[];
    resortList: any[];
    onRemove:any;
}
class ResortDropdownSelectedList extends React.Component<Props, {}> {
  constructor(props:Props) {
    super(props);
  }

  render() {

    return (
        <ul className="selected">
            {this.props.selected.map((resortId: string) => {
              let resort = this.props.resortList.filter((resort: any) => {
                return resort.resortId === resortId;
              })[0];
              return (
                <ResortDropdownSelectedItem
                  key={resortId}
                  id={resortId}
                  onRemove={this.props.onRemove}
                  resort={resort}
                />
              );
            })
            }
        </ul>
    )
  }
}
export default ResortDropdownSelectedList;
